let localIsLogin=window.localStorage.getItem("isloguin");
let localUser=window.localStorage.getItem("usuario");
let LocalGrupo=window.localStorage.getItem("grupo")


const initialState= {isloguin:localIsLogin,
					usuario:localUser,
					open:false,
					urlVideo:"",
					grupo:LocalGrupo,
					data:"",
					dataRutas:"",
					id:"",
					idCopied:"",
					runTest:false,
					hardware:"",
					speedTest:"comprueba tu velocidad de internet aqui!",
					instal:false,
					openRutas:0,
					ruta:0,
					paso:0,
					busqueda:"",
				}; 

export default function reducer(state= initialState,action){
	switch(action.type){

     	case 'loguin':
		
			window.localStorage.setItem("isloguin",true);
			window.localStorage.setItem('usuario',action.payload);		
			return {...state, usuario:action.payload,isloguin:true};


		case 'usuario':
			
			return {...state, usuario:action.payload};

	 	case 'logout':

		   window.localStorage.setItem("isloguin",false);
		   window.localStorage.removeItem('usuario');
	         return {...state,isloguin:false,usuario:null};

	  	case 'setData':		
				
			return {...state,data:action.payload};

	  	case 'setDataRutas':		
				
			return {...state,dataRutas:action.payload};

		case 'urlvideo':		
				
			return {...state,urlVideo:action.payload};
		case 'open':		
				
			return {...state,open:action.payload};

		case 'id':		
				
			return {...state,id:action.payload};
		case 'idCopy':		
				
			return {...state,idCopied:action.payload};

		case 'speedTest':		
				
			return {...state,speedTest:action.payload};

		case 'runTest':		
				
			return {...state,runTest:action.payload};
	  	
	  	case 'instal':		
				
			return {...state,instal:action.payload};

		case 'hardware':		
				
			return {...state,hardware:action.payload};

	  	case 'grupo':
	  			
	    	window.localStorage.setItem("grupo",action.payload)	
			return {...state,grupo:action.payload};


      	case 'player':

	   	    return {...state,player:action.payload};

      	case 'setStep':

	   	    return {...state,paso:action.payload};

      	case 'nroRuta':

	   	    return {...state,ruta:action.payload};

      	case 'menuRutas':

	   	    return {...state,openRutas:action.payload};

	   	case 'busqueda':

	   	    return {...state,busqueda:action.payload};


	 default:
      return state}


	}




